/* eslint-disable jsx-a11y/alt-text */
import React, { memo, useState } from 'react';
import { Col, Image } from 'antd';
import styled from 'styled-components';
import '../home/print.css';
import { formatCurrency } from '../../utils';
import dayjs from 'dayjs';

type Props = {
  action: {
    loading: boolean;
    payload: any;
  };
  printRef: any;
};

const ValuationDetail = memo(({ action, printRef }: Props) => {
  const [payload] = useState(action.payload);

  if (!payload) return <></>;

  return (
    <div>
      <Root ref={printRef} className="printRoot table">
        <div className="flex-col pt-4 pr-[10px] pl-[10px] hidden print:inline">
          <div className="flex flex-row items-end justify-between">
            <img src={require('../../assets/main-logo.png')} className="w-[120px]" />
            <div>
              <div className="text printText">
                Зээлийн үйл ажиллагааны журмын хавсралт F-84-04-4
              </div>
            </div>
          </div>
          <div className="h-[30px]" />
          <div className="h8" />
          <div className="bold">Автомашины үнэлгээний тайлан</div>
        </div>
        <div className="bold printRadio">Автомашины үнэлгээний тайлан</div>
        <div className="body">
          <div className="h8" />
          <div className="title">Үнэлсэн автомашины тайлан</div>
          <div className="h8" />
          <div className="flex flex-row ">
            <table border={1} className="table printTable">
              <tr>
                <td className="label printLabel">Зээл хүсэгчийн овог, нэр</td>
                <td className="value printValue">{payload?.customer?.fullName}</td>
              </tr>
              <tr>
                <td className="label printLabel">Регистрийн дугаар</td>
                <td className="value printValue">{payload?.customer?.registerNo}</td>
              </tr>
            </table>

            <table border={1} className="table printTable">
              <tr>
                <td className="label printLabel">Үнэлсэн ажилтны нэр</td>
                <td className="value printValue">
                  {payload?.valuationUser?.lastName} {payload?.valuationUser?.firstName}
                </td>
              </tr>
              <tr>
                <td className="label printLabel">Тайлангийн огноо</td>
                <td className="value printValue">
                  {dayjs(payload?.createdAt).format('YYYY-MM-DD')}
                </td>
              </tr>
            </table>
          </div>
          <div className="h8" />
          <div className="title">Үнэлсэн автомашины мэдээлэл</div>
          <div className="h8" />
          <div className="row">
            <table border={1} className="table printTable">
              <tr>
                <td className="label printLabel">Үндсэн мэдээлэл</td>
                <td></td>
              </tr>
              <tr>
                <td className="label printLabel">Марк</td>
                <td className="value printValue">{payload?.vehicle?.carBrand?.name}</td>
              </tr>
              <tr>
                <td className="label printLabel">Загвар</td>
                <td className="value printValue">{payload?.vehicle?.carModel?.name}</td>
              </tr>
              <tr>
                <td className="label printLabel">Улсын дугаар</td>
                <td className="value printValue">{payload?.vehicle?.plateNumber}</td>
              </tr>

              <tr>
                <td className="label printLabel">Арлын дугаар</td>
                <td className="value printValue">{payload?.vehicle?.vin}</td>
              </tr>
              <tr>
                <td className="label printLabel">Үйлдвэрлэсэн он</td>
                <td className="value printValue">{payload?.vehicle?.manufacturedYear}</td>
              </tr>

              <tr>
                <td className="label printLabel">Монгол Улсад орж ирсэн он</td>
                <td className="value printValue">{payload?.vehicle?.importedYear}</td>
              </tr>
              <tr>
                <td className="label printLabel">Зориулалт</td>
                <td className="value printValue">{payload?.vehicle?.type}</td>
              </tr>
              <tr>
                <td className="label printLabel">Явсан км</td>
                <td className="value printValue">{payload?.vehicle?.odo}</td>
              </tr>
            </table>

            <table border={1} className="table printTable">
              <tr>
                <td className="label printLabel">Хүчин чадал болон нэмэлт мэдээлэл</td>
                <td className="value printValue"></td>
              </tr>
              <tr>
                <td className="label printLabel">Хөдөлгүүрийн төрөл</td>
                <td className="value printValue">{payload?.vehicle?.engineType}</td>
              </tr>
              <tr>
                <td className="label printLabel">Хөтлөгч</td>
                <td className="value printValue">{payload?.vehicle?.drivetrain}</td>
              </tr>
              <tr>
                <td className="label printLabel">Хөдөлгүүрийн багтаамж</td>
                <td className="value printValue">{payload?.vehicle?.engineCapacity}</td>
              </tr>
              <tr>
                <td className="label printLabel">Хурдны хайрцаг</td>
                <td className="value printValue">{payload?.vehicle?.transmission}</td>
              </tr>
              <tr>
                <td className="label printLabel">Хүрдний байрлал</td>
                <td className="value printValue">{payload?.vehicle?.steering}</td>
              </tr>

              <tr>
                <td className="label printLabel">Тоноглол</td>
                <td className="value printValue">{payload?.vehicle?.option}</td>
              </tr>
              <tr>
                <td className="label printLabel">Гадна өнгө</td>
                <td className="value printValue">{payload?.vehicle?.exteriorColor}</td>
              </tr>
              <tr>
                <td className="label printLabel">Салоны өнгө</td>
                <td className="value printValue">{payload?.vehicle?.interiorColor}</td>
              </tr>
            </table>
          </div>

          <div className="h8" />

          <div className="col">
            <div className="row printJustifyCenter">
              {(payload?.vehicleImages || []).map((item: any, index: number) => (
                <Col key={index}>
                  <Image className="image printImage" width={188} height={150} src={item?.url} />
                </Col>
              ))}
            </div>

            <div className="h8" />
          </div>
          <div className="h8" />
          <table border={1} className="table printTable">
            <tr>
              <td className="label printLabel" width={150}>
                Үнэлгээний аргачлал
              </td>
              <td className="value printValue">{payload.description}</td>
            </tr>
          </table>

          <div className="h8" />
          <table border={1} className="table printTable">
            <tr>
              <td className="label printLabel" width={150}>
                Зохицуулагдсан үнэлгээ
              </td>
              <td className="value printValue">{formatCurrency(payload.price)}</td>
            </tr>
          </table>

          <div className="h8" />
          <table border={1} className="table printTable">
            <tr>
              <td className="label printLabel" width={150}>
                Километрийн заалтаас хамаарсан зохицуулалт
              </td>
              <td className="value printValue custom">{payload.percentOdo}%</td>
              <td className="value printValue">Салбарын удирдлагын зохицуулалт</td>
              <td className="value printValue">
                <span className="value printValue custom">{payload.percentBranchHead}%</span>
              </td>
            </tr>
          </table>

          <div className="h8" />
          <table border={1} className="table printTable">
            <tr>
              <td className="label printLabel" width={150}>
                Эцэслэсэн үнэлгээ
              </td>
              <td className="value printValue custom">{formatCurrency(payload.priceFinal)}</td>
            </tr>
          </table>
          <div className="h-[80px]" />
          <div className="row printRow">
            <table border={1} className="table printTable">
              <tr>
                <td className="label printLabel" width={150}>
                  Үнэлсэн ажилтны нэр
                </td>
                <td className="value printValue">{payload?.valuationUser?.fullName}</td>
              </tr>
              <tr>
                <td className="label printLabel" width={150}>
                  Гарын үсэг
                </td>
                <td className="value printValue"></td>
              </tr>
            </table>

            <table border={1} className="table printTable">
              <tr>
                <td className="label printLabel" width={160}>
                  Хянасан удирдлагын нэр
                </td>
                <td className="value printValue">
                  {payload?.branchHead?.lastName + ' ' + payload?.branchHead?.firstName}
                </td>
              </tr>
              <tr>
                <td className="label printLabel" width={150}>
                  Гарын үсэг
                </td>
                <td className="value printValue"></td>
              </tr>
            </table>
          </div>
          <div className="hidden print:inline print-pt" />
          <div className="flex flex-row justify-end">
            <div className="hidden print:inline">{payload.sequence}</div>
          </div>
        </div>
      </Root>
    </div>
  );
});

ValuationDetail.displayName = 'ValuationDetail';

const Root = styled.div`
  /* border: solid 1px #f6f4f4; */
  width: 100%;
  width: 800px;
  height: '100%';

  .header {
    height: 170px;
    padding: 8px;
  }
  .table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  .body {
    padding: 10px;
  }
  .label {
    font-weight: 500;
    font-size: 12px;
    padding: 4px;
  }
  .value printValue {
    font-size: 12px;
  }
  .row {
    display: flex;
    flex-direction: row;
  }
  .space-between {
    justify-content: space-between;
  }
  .title {
    margin-top: 8px;
    margin-bottom: 8px;
    font-weight: 600;
  }
  .custom {
    font-weight: 900;
    font-size: 13px;
  }
  .image {
    object-fit: cover;
    background-color: #f4f4f4;
    margin-top: 10px;
  }
  .tag {
    border: solid 1px #d9d9d9;
    padding: 4px;
    font-size: 12px;
  }
  .logo {
    width: 250px;
    border: solid 1px white;
  }

  .header-title {
    padding: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .text {
    width: 250px;
    text-align: right;
  }
  .bold {
    flex: 1;
    display: flex;
    font-size: 18px;
    font-weight: 700;
    padding-top: 10px;
    justify-content: center;
  }
  td {
    padding: 4px;
  }
`;

export { ValuationDetail };
